export const themeColor = "#006239";
export const projectTitle = "Citizen to Government Platform";
 
export const ENCRIPTION_PASSCODE = "cgp!l#at@f$orm54@7";


export const apiURL = "https://egovapi.plateaustate.gov.ng/";

// export const apiURL = "http://localhost:4000/";
// export const apiURL = "https://user.citigov.com.ng/backend";
// export const baseURL = "https://my.citigov.ng";


export const admin = "https://egovadmin.plateaustate.gov.ng";
export const mda = "https://egovmda.plateaustate.gov.ng";
export const baseURL = "https://egovuser.plateaustate.gov.ng";